export const PAGE_SIZE = 50;

export const TABS = [
  { name: "buh_docs",   label: "Бух документация" },
  { name: "exec_docs",  label: "M19" },
  { name: "agreements", label: "Договора проекта" },
  { name: "invoices",   label: "Накладные (материалы)" },
];

export {
  BUH_DOC_TYPE_IDS,
  EXEC_DOC_TYPE_IDS,
  FLOOR_MAP_DOC_TYPE_ID_BUH_AVR,
  FLOOR_MAP_DOC_TYPE_ID_M19_OVER,
  sortFloorMapDocTypeIdsForTab,
  UNSIGNED_DOC_TYPE_FALLBACK_LABEL,
} from "./doc-type-ids";

export const SIGNED_OPTIONS = [
  { value: "false", label: "Не подписанные" },
  { value: "true",  label: "Подписанные" },
  { value: "all",   label: "Все" },
];

export const SEND_TO_1C_OPTIONS = [
  { value: null,  label: "Все" },
  { value: 0,     label: "Не отправлен" },
  { value: 1,     label: "Ожидает отправки" },
  { value: 2,     label: "Отправлен в 1С" },
];

export const MANUAL_OPTIONS = [
  { value: null,    label: "Все" },
  { value: "true",  label: "Ручные накладные" },
  { value: "false", label: "Электронные накладные" },
];

/** Единый мультивыбор «подписание + ЭСФ» в журнале документов (buh/exec). Поле опции — `tag`. */
export const DOC_AUDIT_FILTER_OPTIONS = [
  { tag: "sign_all",      label: "Подписание: все" },
  { tag: "sign_unsigned", label: "Не подписанные" },
  { tag: "sign_signed",   label: "Подписанные" },
  { tag: "esf_all",       label: "ЭСФ: все" },
  { tag: "esf_yes",       label: "Есть ЭСФ" },
  { tag: "esf_no",        label: "Нет ЭСФ" },
];

/** Фильтр журнала документов по признаку «есть данные ЭСФ» (как hasEsfInfo на фронте). */
export const ESF_FILTER_OPTIONS = [
  { value: "all", label: "Все" },
  { value: "true", label: "Есть ЭСФ" },
  { value: "false", label: "Нет ЭСФ" },
];

export const invoicesColumns = [
  { name: "project_info",  field: "project_info",  label: "Проект",            align: "left",   style: "width:19%" },
  { name: "invoice_info",  field: "invoice_info",  label: "Накладная",         align: "left",   style: "width:18%" },
  { name: "parties",       field: "parties",       label: "Стороны",           align: "left",   style: "width:39%" },
  { name: "status_action", field: "status_action", label: "Статус / Действие", align: "center", style: "width:24%" },
  // служебные поля
  { name: "srv_invoice_id",  field: "provider_request_invoice_id", label: "[ID накладной]",  align: "left", style: "font-family:monospace", service: true },
  { name: "srv_project_id",  field: "project_id",                  label: "[project_id]",    align: "left", style: "font-family:monospace", service: true },
  { name: "srv_sbs_id",      field: "sbs_project_id",              label: "[sbs_project_id]",align: "left", style: "font-family:monospace", service: true },
];

export const agreementsColumns = [
  { name: "project_info",    field: "project_info",    label: "Проект",            align: "left",   style: "width:20%" },
  { name: "agreement_info",  field: "agreement_info",  label: "Договор",           align: "left",   style: "width:20%" },
  { name: "contractor_info", field: "contractor_info", label: "Контрагент",        align: "left",   style: "width:16%" },
  { name: "signer_info",     field: "signer_info",     label: "Подписант",         align: "left",   style: "width:20%" },
  { name: "status_action",   field: "status_action",   label: "Статус / Действие", align: "center", style: "width:24%" },
  // служебные поля
  { name: "srv_agreement_id",   field: "project_agreement_id",        label: "[project_agreement_id]",        align: "left", style: "font-family:monospace", service: true },
  { name: "srv_cal_id",         field: "contractor_agreement_list_id", label: "[contractor_agreement_list_id]", align: "left", style: "font-family:monospace", service: true },
  { name: "srv_project_id",     field: "project_id",                  label: "[project_id]",                  align: "left", style: "font-family:monospace", service: true },
  { name: "srv_project_type_id",field: "project_type_id",             label: "[project_type_id]",             align: "left", style: "font-family:monospace", service: true },
  { name: "srv_sbs_id",         field: "sbs_project_id",              label: "[sbs_project_id]",              align: "left", style: "font-family:monospace", service: true },
];

export const documentsColumns = [
  { name: "project_info",    field: "project_info",    label: "Проект",             align: "left",   style: "width:19%" },
  { name: "doc_info",        field: "doc_info",        label: "Документ",           align: "left",   style: "width:18%" },
  { name: "contractor_info", field: "contractor_info", label: "Контрагент",         align: "left",   style: "width:16%" },
  { name: "signers",         field: "signers",         label: "Подписанты",         align: "left",   style: "width:28%" },
  { name: "status_action",   field: "status_action",   label: "Статус / Действие",  align: "center", style: "width:19%" },
  // служебные поля
  { name: "srv_doc_id",      field: "floor_map_document_id", label: "[floor_map_document_id]", align: "left", style: "font-family:monospace", service: true },
  { name: "srv_entrance_id", field: "project_entrance_id",   label: "[project_entrance_id]",   align: "left", style: "font-family:monospace", service: true },
  { name: "srv_project_id",  field: "project_id",            label: "[project_id]",            align: "left", style: "font-family:monospace", service: true },
  { name: "srv_sbs_id",      field: "sbs_project_id",        label: "[sbs_project_id]",        align: "left", style: "font-family:monospace", service: true },
];

export const normalColNames = (columns) =>
  columns.filter((c) => !c.service).map((c) => c.name);

export const signStatusColor = (status) => {
  if (!status || status === "WAITING") return "orange";
  if (status === "FAILED")             return "negative";
  if (status === "SIGNED")             return "positive";
  return "grey";
};

export const signStatusLabel = (status) => {
  if (!status)               return "Не отправлено";
  if (status === "WAITING")  return "Ожидает подписи";
  if (status === "FAILED")   return "Ошибка подписи";
  if (status === "SIGNED")   return "Подписано";
  return status;
};
